import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    changePassword: translate({ id: 'settings.users.view.changePasswordModal.controls.send' }),
    warning: translate({ id: 'settings.users.view.changePasswordModal.warning' }),
    cancel: translate({ id: 'settings.users.view.changePasswordModal.controls.cancel' }),

    changePasswordSuccess: translate({
      id: 'settings.users.view.changePasswordModal.toast.success',
    }),
    changePasswordGenericError: translate({
      id: 'settings.users.view.changePasswordModal.toast.genericError',
    }),
  }))

  return api
}
